import { GETSESSIONDASHBOARD_SUCCESS, GETSESSIONDASHBOARD_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getSessionDashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETSESSIONDASHBOARD_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETSESSIONDASHBOARD_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: [],
            };
        default:
            break;
    }

    return state;
};

export default getSessionDashboardReducer;



